module.exports = __webpack_public_path__ + "pinch.svg?ab07e8c74e4f5785141dcfcfbb8c484f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pinch.svg
// module id = 56
// module chunks = 0